<template>
    <v-container fluid class="header-nav" :class="{ 'header-nav--two-row': twoRow }">
        <v-container class="header-nav__bar">
            <v-row>
                <!-- 로고 -->
                <v-col cols="auto" class="header-nav__logo">
                    <router-link :to="currentUserShopSlug ? '/' + currentUserShopSlug : { name: 'Home' }" class="hn-logo">
                        <template v-if="currentCategoryImage">
                            <img :src="currentCategoryImage" :alt="currentCategoryName" class="hn-logo__category" />
                        </template>
                        <template v-else-if="shopLogo">
                            <img :src="shopLogo" :alt="appName" class="hn-logo__shop" />
                        </template>
                        <template v-else>
                            <img src="/assets/img/header/header-bi.svg" :alt="appName" class="hn-logo__bi" />
                            <img src="/assets/img/header/header-logo.svg" :alt="appName" class="hn-logo__default" />
                        </template>
                    </router-link>
                </v-col>

                <v-col class="header-nav__left">
                    <!-- 전체 메뉴 버튼 -->
                    <button v-if="shopUseHamburgerMenu" class="header-nav__hamburger" v-bind:class="{ 'is-active': flags.isServiceNavOpen }" v-on:click="toggleServiceNav">
                        <i class="las fs-29" v-bind:class="flags.isServiceNavOpen ? 'la-times' : 'la-bars'"></i>
                    </button>

                    <!-- GNB -->
                    <nav v-if="shopUseTopMenu" class="gnb">
                        <ul class="gnb__list">
                            <li
                                v-for="(menu, mIndex) in menus"
                                v-bind:key="mIndex"
                                class="gnb__item"
                                v-on:mouseenter="openDropdown(mIndex)"
                                v-on:mouseleave="closeDropdown(mIndex)"
                            >
                                <router-link
                                    v-bind:to="menu.GROUP.LINK || '#'"
                                    class="gnb__link"
                                    v-bind:class="{ 'is-active': states.hoveredMenuIndex === mIndex || isRouteActive(menu.GROUP.LINK) }"
                                >
                                    <span>{{ menu.GROUP.SHORTNAME || menu.GROUP.NAME }}</span>
                                </router-link>

                                <!-- Mega Menu Dropdown -->
                                <v-container fluid class="gnb__mega" v-bind:class="{ 'is-open': states.hoveredMenuIndex === mIndex }">
                                    <v-container class="gnb__mega-inner">
                                        <div class="gnb__sections">
                                            <div v-for="(sectionData, sIndex) in menu.SECTIONS" v-bind:key="sIndex" class="gnb__section">
                                                <h3 class="gnb__section-title">
                                                    <span>{{ sectionData.SECTION.NAME }}</span>
                                                </h3>
                                                <div class="gnb__tabs">
                                                    <div v-for="(tab, tIndex) in sectionData.TABS" v-bind:key="tIndex" class="gnb__tab">
                                                        <h4 class="gnb__tab-title" v-if="tab.TYPE === 'tab'">
                                                            <span>{{ tab.NAME }}</span>
                                                        </h4>
                                                        <ul class="gnb__items">
                                                            <li v-for="(item, iIndex) in tab.ITEMS" v-bind:key="iIndex" class="gnb__sub-item">
                                                                <router-link v-bind:to="item.LINK">{{ item.NAME }}</router-link>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <!-- 우측 브랜드/프로모션 영역 -->
                                        <div class="gnb__brand">
                                            <div class="gnb__promo-placeholder"></div>
                                            <div class="gnb__brand-footer">
                                                <p class="gnb__brand-text">
                                                    <span>환경친화적 인쇄를 지향하는</span>
                                                    <br />
                                                    <span>인쇄 넘버원,</span>
                                                    <b>프리원!</b>
                                                </p>
                                                <img src="/assets/img/soyinkmark.svg" alt="인증마크" class="gnb__brand-logo" />
                                            </div>
                                        </div>
                                    </v-container>
                                </v-container>
                            </li>
                        </ul>
                    </nav>
                </v-col>

                <!-- Right Side User Icons -->
                <v-col class="header-nav__right">
                    <div v-for="(menuLabel, i) in $optional('data.logobar_menu?.labels')" v-bind:key="i" class="header-nav__icon">
                        <v-tooltip attach bottom transition="slide-y-transition">
                            <template v-slot:activator="{ on, attrs }">
                                <router-link v-bind:to="!isAuthenticated && shopSlug ? loginLink : $optional('data.logobar_menu.links')[i]" class="text-reset d-block pa-2 mx-1">
                                    <i class="las fs-30 position-relative" v-bind="attrs" v-on="on" v-bind:class="$optional('data.logobar_menu.icons')[i]">
                                        <v-badge
                                            color="error"
                                            v-bind:content="getCartCount"
                                            inline
                                            v-if="getCartCount > 0 && $optional('data.logobar_menu.links')[i] === '/cart'"
                                            class="header-nav__badge"
                                        ></v-badge>
                                    </i>
                                </router-link>
                            </template>
                            <span>{{ menuLabel }}</span>
                        </v-tooltip>
                    </div>

                    <div v-if="!isAuthenticated" class="header-nav__icon">
                        <v-tooltip attach bottom transition="slide-y-transition">
                            <template v-slot:activator="{ on, attrs }">
                                <router-link v-bind:to="loginLink" class="text-reset d-block pa-2 mx-1">
                                    <i v-bind="attrs" v-on="on" class="las la-sign-in-alt fs-30"></i>
                                </router-link>
                            </template>
                            <span>로그인</span>
                        </v-tooltip>
                    </div>
                    <div v-else class="header-nav__icon">
                        <v-tooltip attach bottom transition="slide-y-transition">
                            <template v-slot:activator="{ on, attrs }">
                                <router-link v-bind:to="{ name: 'Logout' }" class="text-reset d-block pa-2 mx-1">
                                    <i v-bind="attrs" v-on="on" class="las la-sign-out-alt fs-30"></i>
                                </router-link>
                            </template>
                            <span>로그아웃</span>
                        </v-tooltip>
                    </div>
                </v-col>
            </v-row>
        </v-container>

        <!-- ServiceNavs Component -->
        <ServiceNavs v-if="shopUseHamburgerMenu" v-bind:show="flags.isServiceNavOpen" v-on:close="flags.isServiceNavOpen = false" />
    </v-container>
</template>

<script>
    import { mapGetters } from 'vuex';
    import { getVisibleMenus } from './menus/index.js';
    import ServiceNavs from './ServiceNavs.vue';

    export default {
        name: 'HeaderNavs',
        components: {
            ServiceNavs,
        },
        props: {
            data: { type: Object, default: () => ({}) },
            twoRow: { type: Boolean, default: false },
        },
        data() {
            return {
                flags: {
                    isServiceNavOpen: false,
                    isLoading: false,
                    timeout: null,
                    serviceNavTimeout: null,
                },
                states: {
                    hoveredMenuIndex: null,
                },
            };
        },
        watch: {
            $route() {
                this.flags.isServiceNavOpen = false;
                this.states.hoveredMenuIndex = null;
            },
        },
        computed: {
            ...mapGetters('cart', ['getCartCount']),
            ...mapGetters('auth', ['isAuthenticated', 'shopTheme', 'shopUseHamburgerMenu', 'shopUseTopMenu', 'currentUserShopSlug', 'guestShopLogo']),
            ...mapGetters('app', ['demoMode', 'appName', 'currentCategoryImage', 'currentCategoryName']),
            menus() {
                return getVisibleMenus(this.shopTheme);
            },
            shopLogo() {
                if (!this.data) return '';
                return this.data.shop_logo || this.guestShopLogo || this.data.home_shop_logo || '';
            },
            shopSlug() {
                if (this.currentUserShopSlug) return this.currentUserShopSlug;
                const redirect = this.$route?.query?.redirect || '';
                return redirect.split('/').filter(Boolean)[0] || null;
            },
            loginLink() {
                if (this.shopSlug) {
                    return { name: 'Login', query: { redirect: '/' + this.shopSlug } };
                }
                return { name: 'Login' };
            },
        },
        methods: {
            toggleServiceNav() {
                if (this.flags.isServiceNavOpen) {
                    window.clearTimeout(this.flags.serviceNavTimeout);
                    this.flags.serviceNavTimeout = window.setTimeout(() => {
                        this.flags.isServiceNavOpen = false;
                    }, 400);
                } else {
                    this.flags.isServiceNavOpen = true;
                    this.states.hoveredMenuIndex = null;
                }
            },
            openDropdown(index) {
                window.clearTimeout(this.flags.timeout);
                this.states.hoveredMenuIndex = index;
                this.flags.isServiceNavOpen = false;
            },
            closeDropdown(index) {
                if (this.states.hoveredMenuIndex === index) {
                    window.clearTimeout(this.flags.timeout);
                    this.flags.timeout = window.setTimeout(() => {
                        this.states.hoveredMenuIndex = null;
                    }, 400);
                }
            },
            isRouteActive(path) {
                if (!path || path === '/') return false;
                return this.$route.path.startsWith(path);
            },
        },
    };
</script>

<style lang="scss" scoped>
.header-nav__logo {
    display: flex;
    align-items: center;
    padding: 0 16px 0 0;

    .hn-logo {
        display: flex;
        align-items: center;
        text-decoration: none;

        &__category {
            // height: 51px;
            width: auto;
            object-fit: contain;
        }
        &__shop {
            // height: 51px;
            width: auto;
            object-fit: contain;
        }
        &__bi {
            height: 31px;
            margin-right: 6px;
        }
        &__default {
            // height: 51px;
        }
    }
}
</style>
